import Service from './service'
export var ApiFilesystemMessageType;
(function (ApiFilesystemMessageType) {
  ApiFilesystemMessageType["FILESYSTEM_CONTROL_REQUEST"] = "filesystem.control.request"
  ApiFilesystemMessageType["FILESYSTEM_CONTROL_RESPONSE"] = "filesystem.control.response"
})(ApiFilesystemMessageType || (ApiFilesystemMessageType = {}))
export var AvailableLoadMimeType;
(function (AvailableLoadMimeType) {
  AvailableLoadMimeType["PNG"] = "image/png"
})(AvailableLoadMimeType || (AvailableLoadMimeType = {}))
export var AvailableSaveMimeType;
(function (AvailableSaveMimeType) {
  AvailableSaveMimeType["PNG"] = "image/png"
  AvailableSaveMimeType["TEXT"] = "text/html"
})(AvailableSaveMimeType || (AvailableSaveMimeType = {}))
/**
 * Сервис для работы с файловой системой
 * @version 0.0.1
 * @since 2.0.0
 */
export default class FilesystemService extends Service {
  /**
     * @ignore
     */
  constructor(messageChannel) {
    super(messageChannel)
    const messageHandler = (message) => {
      switch (message.type) {
        case ApiFilesystemMessageType.FILESYSTEM_CONTROL_RESPONSE:
          this.resolve(this.waiters.filesystem, message.file)
          break
      }
    }
    this.waiters = {
      filesystem: [],
    }
    this.messageChannel.subscribe(ApiFilesystemMessageType.FILESYSTEM_CONTROL_RESPONSE, messageHandler)
  }
  /**
     * Загрузить файл из домашней папки робота (/home/promobot/) .
     * Метод используется, если необходимо получить base64 файла из директории робота к которому нет доступа через JS
     *
     * @since 2.0.0
     * @param {AvailableLoadMimeType} mimeType - MIME-тип файла
     * @param {string} fileName - путь к файлу в домашней папке (/home/promobot/)
     * @return {*}  {Promise<Base64>}
     * @memberof FilesystemService
     *
     * @example <caption>Загрузить файл</caption>
     * const fullPath = await robot.cameraService.makePhoto()
     * const filename = fullPath.split("/home/promobot/").pop()
     * robot.filesystemService.loadFile(mimeType, filename).then((base64) => {
     * })
     */
  loadFile(mimeType, fileName) {
    return this.execute({
      type: ApiFilesystemMessageType.FILESYSTEM_CONTROL_REQUEST,
      load_file: '',
      mime_type: mimeType,
      filename: fileName,
    }, this.waiters.filesystem)
  }
  /**
     * Сохранить в файл
     *
     * @since 2.0.0
     * @param {AvailableSaveMimeType} mimeType - MIME-тип файла
     * @param {string} data - данные для записи в файл
     * @param {string} fileName - путь к файлу
     * @memberof FilesystemService
     *
     * @example <caption>Сохранить в файл</caption>
     * robot.filesystemService.saveFile(mimeType, data, fileName)
     */
  saveFile(mimeType, data, fileName) {
    this.messageChannel.send({
      type: ApiFilesystemMessageType.FILESYSTEM_CONTROL_REQUEST,
      save_file: '',
      mime_type: mimeType,
      filename: fileName,
      data,
    })
  }
}
